export const REMOVE_CUSTOMERS_COMMENT_REQUEST = 'REMOVE_CUSTOMERS_COMMENT_REQUEST';
export const REMOVE_CUSTOMERS_COMMENT_SUCCESS = 'REMOVE_CUSTOMERS_COMMENT_SUCCESS';
export const REMOVE_CUSTOMERS_COMMENT_FAILURE = 'REMOVE_CUSTOMERS_COMMENT_FAILURE';
